import { Flex, type FlexProps, Icon } from "@chakra-ui/react";

interface GreenIconBadgeProps extends Omit<FlexProps, "children"> {
  icon: React.ElementType;
  outerSize?: FlexProps["w"];
  iconBoxSize?: number | Record<string, number>;
  hover?: boolean;
  groupHover?: boolean;
}

const hoverStyles = {
  transform: "translateY(-3px)",
  boxShadow: "0 12px 28px rgba(34, 197, 94, 0.38)",
};

export function GreenIconBadge({
  icon,
  outerSize = "3rem",
  iconBoxSize = 5,
  hover = false,
  groupHover = false,
  ...rest
}: GreenIconBadgeProps) {
  return (
    <Flex
      w={outerSize}
      h={outerSize}
      rounded="full"
      align="center"
      justifyContent="center"
      bg="linear-gradient(180deg, #22C55E 0%, #16A34A 100%)"
      boxShadow="0 8px 20px rgba(34, 197, 94, 0.30)"
      border="3px solid white"
      transition="all 0.28s ease"
      _hover={hover ? hoverStyles : undefined}
      _groupHover={groupHover ? hoverStyles : undefined}
      {...rest}
    >
      <Icon as={icon} boxSize={iconBoxSize} strokeWidth={2} color="white" />
    </Flex>
  );
}
